import type { HgSupportedLanguage } from '@smg-real-estate/domus';

import type { AgentSearchFacets } from '@/helpers/AgentDirectory/agentFacetRouteParams';
import { isSameAgentSearch } from '@/helpers/AgentDirectory/agentRouteParams';
import { useAgentProfilesStore } from '@/stores/agentProfiles';
import { resolveGeoLocations } from '@/stores/geoLocationHelpers';
import { LoadState } from '@/stores/types';

export async function syncAgentDirectoryFromRoute({
  geoLocations,
  locale,
  currentPage,
  facets,
}: {
  geoLocations: string[];
  locale: HgSupportedLanguage;
  currentPage: number;
  facets: AgentSearchFacets;
}): Promise<void> {
  const store = useAgentProfilesStore();
  const generation = store.beginAgentRouteSync();
  const resolvedLocations = await resolveGeoLocations(geoLocations, locale);

  if (generation !== store.agentsRequestGeneration) {
    return;
  }

  if (
    store.agentsLoadState === LoadState.LOADED &&
    isSameAgentSearch({
      resolvedLocations,
      currentPage,
      searchedLocations: store.searchedLocations,
      loadedPage: store.agentListCurrentPage,
      facets,
      searchedFacets: store.searchedFacets,
    })
  ) {
    store.setRouteResolvedLocations(resolvedLocations, facets);
    return;
  }

  await store.applyUrlParamsFilters({
    geoLocations,
    locale,
    currentPage,
    requestGeneration: generation,
    resolvedLocations,
    facets,
  });
}
